import React from "react";

interface VaccineProps{
  width ?: any;
  height ?: any;
}

const Vaccine : React.FC<VaccineProps> = ({width = 25 , height = 25}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24.558 24.558">
      <g transform="translate(0.308 0.25)">
        <g transform="translate(0 0)">
          <path
            d="M.205,22.8l3.4-3.4-.5-.5a.7.7,0,0,1,0-.994l.788-.788v-1.7a.717.717,0,0,1,.206-.5L13.85,5.179a.7.7,0,0,1,.994,0l.5.5L19.319,1.7l-.5-.5a.7.7,0,1,1,.994-.994l3.977,3.977a.7.7,0,1,1-.994.994l-.5-.5L18.324,8.66l.5.5a.7.7,0,0,1,0,.994L9.078,19.895a.7.7,0,0,1-.5.206h-1.7l-.788.788a.7.7,0,0,1-.994,0l-.5-.5L1.2,23.8A.7.7,0,0,1,.205,22.8Zm21.1-19.113-.994-.994L16.336,6.671l.994.994ZM17.33,9.654,14.347,6.671l-.994.994,2.983,2.983Zm-4.275,4.275,2.286-2.286L12.358,8.66,5.8,15.213a8.332,8.332,0,0,0,1.881.505A6.039,6.039,0,0,0,13.055,13.929ZM5.6,19.4l.5-.5a.7.7,0,0,1,.5-.206h1.7L9.881,17.1a7.985,7.985,0,0,1-2.394.007,9.745,9.745,0,0,1-2.181-.583v.881a.7.7,0,0,1-.206.5l-.5.5Zm13.48-6.646H21.89A2.112,2.112,0,0,1,24,14.861v1.406a.7.7,0,0,1-.7.7v.537l.629,1.258A.7.7,0,0,1,24,19.08V23.3a.7.7,0,0,1-.7.7H17.671a.7.7,0,0,1-.7-.7V19.08a.7.7,0,0,1,.074-.314l.629-1.258V16.97a.7.7,0,0,1-.7-.7V14.861A2.112,2.112,0,0,1,19.078,12.751Zm-.7,9.844h4.219v-3.35l-.629-1.258a.7.7,0,0,1-.074-.314v-.7H19.078v.7a.7.7,0,0,1-.074.314l-.629,1.258Zm0-7.031h4.219v-.7a.7.7,0,0,0-.7-.7H19.078a.7.7,0,0,0-.7.7Z"
            transform="translate(0 -0.002)"
            stroke="#fff"
            strokeWidth="0.5"
          />
        </g>
      </g>
    </svg>
  );
};

export default Vaccine;
